"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FocusManager = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _tabbable = require("tabbable");
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
/* eslint-disable class-methods-use-this */
var FocusManager = exports.FocusManager = exports.default = /*#__PURE__*/(0, _createClass2.default)(function FocusManager(_ref) {
  var _this = this,
    _this$tabbableNodes;
  var trapNode = _ref.trapNode,
    getTabbableNodes = _ref.getTabbableNodes,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    nextKeyCode = _ref.nextKeyCode,
    previousKeyCode = _ref.previousKeyCode,
    firstFocusIndex = _ref.firstFocusIndex,
    suppressInitialAttachment = _ref.suppressInitialAttachment,
    stopKeyPressPropagation = _ref.stopKeyPressPropagation,
    trapWithTabbing = _ref.trapWithTabbing,
    onlyContainedEvents = _ref.onlyContainedEvents,
    useHomeAndEndKeys = _ref.useHomeAndEndKeys,
    skipEvent = _ref.skipEvent;
  (0, _classCallCheck2.default)(this, FocusManager);
  (0, _defineProperty2.default)(this, "detach", function () {
    document.removeEventListener('keydown', _this.keyHandler);
  });
  (0, _defineProperty2.default)(this, "isFocusContained", function () {
    return _this.container && _this.container.contains(document.activeElement) || _this.tabbableNodes.length && _this.tabbableNodes.some(function (node) {
      return node.contains(document.activeElement);
    });
  });
  (0, _defineProperty2.default)(this, "updateTabbableNodes", function () {
    _this.tabbableNodes = _this.getTabbableNodes();
  });
  (0, _defineProperty2.default)(this, "getIsPreviousKey", function (event) {
    var isShiftTab = event.keyCode === _keycode.default.codes.tab && event.shiftKey;
    if (typeof _this.previousKeyCode === 'undefined') {
      return isShiftTab;
    }
    var isPreviousKey = event.keyCode === _this.previousKeyCode;
    return _this.trapWithTabbing ? isShiftTab || isPreviousKey : isPreviousKey;
  });
  (0, _defineProperty2.default)(this, "getIsNextKey", function (event) {
    var isTabKey = event.keyCode === _keycode.default.codes.tab;
    if (typeof _this.nextKeyCode === 'undefined') {
      return isTabKey;
    }
    var isNextKey = event.keyCode === _this.nextKeyCode;
    return _this.trapWithTabbing ? isTabKey || isNextKey : isNextKey;
  });
  (0, _defineProperty2.default)(this, "keyHandler", function (e) {
    if (!document.body.contains(_this.container)) {
      document.removeEventListener('keydown', _this.keyHandler);
      return;
    }
    if (_this.onlyContainedEvents && !_this.container.contains(e.target)) {
      return;
    }
    if (typeof _this.skipEvent === 'function' && _this.skipEvent(e)) {
      return;
    }
    var isPreviousKey = _this.getIsPreviousKey(e);
    var isNextKey = _this.getIsNextKey(e);
    var isHomeKey = (0, _keycode.default)(e) === 'home';
    var isEndKey = (0, _keycode.default)(e) === 'end';
    if (isPreviousKey || isNextKey || _this.useHomeAndEndKeys && (isHomeKey || isEndKey)) {
      e.preventDefault();
      if (_this.stopKeyPressPropagation) {
        e.stopPropagation();
      }
      _this.updateTabbableNodes();
      if (!_this.isFocusContained(e)) {
        _this.tryFocus(_this.tabbableNodes[0]);
      }
      var currentIndex = _this.tabbableNodes.indexOf(e.target);
      var lastNode = _this.tabbableNodes[_this.tabbableNodes.length - 1];
      var firstNode = _this.tabbableNodes[0];
      if (isPreviousKey) {
        if (_this.tabbableNodes[currentIndex] === firstNode) {
          _this.tryFocus(lastNode);
        } else if (currentIndex < 0) {
          _this.tryFocus(firstNode);
        } else {
          _this.tryFocus(_this.tabbableNodes[currentIndex - 1]);
        }
      } else if (isNextKey) {
        if (_this.tabbableNodes[currentIndex] === lastNode) {
          _this.tryFocus(firstNode);
        } else {
          _this.tryFocus(_this.tabbableNodes[currentIndex + 1]);
        }
      } else if (isHomeKey) {
        _this.tryFocus(firstNode);
      } else if (isEndKey) {
        _this.tryFocus(lastNode);
      }
    }
  });
  (0, _defineProperty2.default)(this, "tryFocus", function (node) {
    if (node) {
      var posX = window.pageXOffset;
      var posY = window.pageYOffset;
      node.focus();
      window.scrollTo(posX, posY);
    }
  });
  this.container = trapNode;
  this.nextKeyCode = nextKeyCode;
  this.previousKeyCode = previousKeyCode;
  this.trapWithTabbing = trapWithTabbing;
  this.stopKeyPressPropagation = !!stopKeyPressPropagation;
  this.onlyContainedEvents = !!onlyContainedEvents;
  this.useHomeAndEndKeys = !!useHomeAndEndKeys;
  this.skipEvent = skipEvent;
  this.getTabbableNodes = typeof getTabbableNodes === 'function' ? getTabbableNodes : function () {
    return (0, _tabbable.tabbable)(_this.container);
  };
  this.updateTabbableNodes();
  document.addEventListener('keydown', this.keyHandler);
  if (!suppressInitialAttachment && (_this$tabbableNodes = this.tabbableNodes) !== null && _this$tabbableNodes !== void 0 && _this$tabbableNodes.length) {
    setTimeout(function () {
      // because this.tryFocus causes auto-scrolling to the focus target,
      // we should allow a delay before it is called.
      // This will prevent the scroll from bouncing around the viewport if
      // the target receives focus and then changes positions.
      // This bug is observed in Popovers on IE11
      // https://github.concur.com/coreui/nui-widgets/issues/912
      if (firstFocusIndex > -1) {
        _this.tryFocus(_this.tabbableNodes[firstFocusIndex]);
      } else {
        _this.tryFocus(_this.tabbableNodes[0]);
      }
    }, delay);
  }
});